import { CheckCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Check = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CheckCircleIcon size={Sizes[size]} {...rest} color={stroke || fill} />;
};

Check.displayName = 'Check';
